export default __webpack_public_path__ + "static/media/Dr.-Majid-Mansouri.4eefb176.png";